/** DNA visit consent URI prefix (matches API / consent store). */
export const DNAVISIT_CONSENT = 'myome:consent:DNAVISIT';

/** Parent/guardian-for-a-minor consent URI prefix (myome:consent:MINOR_CONSENT-<version>). */
export const MINOR_CONSENT = 'myome:consent:MINOR_CONSENT';

/** Consent store code requested from the API for the minor consent. */
export const MINOR_CONSENT_CODE = 'MINOR_CONSENT';
